import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { JetStatusProvider } from './context/JetStatusProvider'
import { JetStatusMain } from './components/JetStatusMain'

export const JetStatus = () => {
  return (
    <NuqsAdapter>
      <JetStatusProvider>
        <JetStatusMain />
      </JetStatusProvider>
    </NuqsAdapter>
  )
}
